const CryptoJS = require("crypto-js"); //引用AES源码js

//加密方法
/*
word 待加密密文
key  秘钥16位
iv   偏移向量16位
*/
export function Encrypt(word, tkey, tiv) {
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let key = CryptoJS.enc.Utf8.parse(tkey);
  let iv = CryptoJS.enc.Utf8.parse(tiv);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  // encrypted.ciphertext.toString()
  return encrypted.toString();
}

//解密方法
export function Decrypt(word, tkey, tiv) {
  // let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  // let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  let key = CryptoJS.enc.Utf8.parse(tkey);
  let iv = CryptoJS.enc.Utf8.parse(tiv);
  let decrypt = CryptoJS.AES.decrypt(word, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  // padding: CryptoJS.pad.Pkcs7 只有ZeroPadding才和C#统一
  let decryptedStr = CryptoJS.enc.Utf8.stringify(decrypt);
  return decryptedStr;
}
